module.exports = __webpack_public_path__ + "img/dealer-customer-login-hover.2cc6c7e2.png";